<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Edit Place of Treatment :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/incidents">
                            Incidents
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link to="/incidents/settings#facilities">
                            Settings - Facilities
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="facility_type_id"><i class="fa fa-edit"></i> Edit</template>
                        <template v-else><i class="fa fa-plus"></i> New</template>
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-xl-8 col-lg-10 col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row form-group">
                                <label :class="{'col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.TypeName}">Place of Treatment Name:</label>
                                <div class="col-md-6 col-sm-8">
                                    <input type="text" name="TypeName" v-model="facility_type.TypeName" :class="{'form-control': true, 'is-invalid': errors.TypeName}" placeholder="Enter Place of Treatment Name" />

                                    <span v-if="errors.TypeName" class="text-danger">
                                        <span v-for="error in errors.TypeName">{{ error }}</span>
                                    </span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'form-group': true}" class="row">
                                <label class="col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                <div class="col-md-6 col-sm-8">
                                    <b-form-checkbox v-model="facility_type.IsActive" :value="1" :unchecked-value="0" plain />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <hr/>
            <button type="button" class="btn btn-success" v-on:click="saveFacilityType(this)" :disabled="saving">
                Save Place of Treatment
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                facility_type_id: this.$route.params.id,
                facility_type: {},
                errors: {},
            }
        },

        methods: {
            getErrorClass: function(attribute) {
                return {
                    'form-group has-error': this.errors[attribute],
                    'form-group': !this.errors[attribute],
                }
            },
            getFacilityType: function() {
                //Get the data
                this.$http
                    .get('admin/facility-types-edit' + (this.facility_type_id ? '/' + this.facility_type_id : ''))
                    .then(response => {
                        //Set all the data
                        this.facility_type = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            saveFacilityType: function() {
                //Show loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Send it
                this.$http
                .post('admin/facility-types-edit' + (this.facility_type_id ? '/' + this.facility_type_id : ''), this.facility_type)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Place of Treatment Saved');

                    //Return to main list?
                    this.$router.push('/incidents/settings#facilities');
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Get the incidents
            this.getFacilityType();
        }
    }
</script>
